module.exports = __webpack_public_path__ + "static/3A841E_2_0-b9cdca4caff9a8220994082807018365.woff2";